export default __webpack_public_path__ + "static/media/clients_customers.1e91dabb.svg";